import BATWS from 'lib/services/batws';
import PageCache from 'lib/page-cache';
import langFromUrl from 'lib/util/langFromUrl';

BATWS.cls().getSeries({ lang: langFromUrl() }).then(function (res) {
  var allSeries = $.extend(true, {}, res);
  var seriesArr = res.seriesDepthOne.series;
  var vehSelect = [];
  seriesArr.forEach(function (series) {
    if (BATSiteConfig.disabledVehicles.indexOf(series.series_code) === -1) {
      var seriesObj = series;
      vehSelect.push(seriesObj);
    }
  });
  res.seriesDepthOne.series = vehSelect;
  PageCache.set('series.raw', res);
  PageCache.set('allseries.raw', allSeries);
});
